import { useMutation } from '@tanstack/react-query';
import { POST, POST_WARRANTY_ADD } from '../../../../services';
import { InsertWarranty } from '../../../../resources/payload';
import { openAlert } from '../../../../components/alert/hooks';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { navigateTo } from '../../../../utils/navigation';

export const useRegAdd = ({ reset }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsertWarranty(values);
      Object.entries(payload).forEach(([key, value]) => {
        if (value != null && value !== undefined) {
          formData.append(key, value);
        }
      });
      const response = await POST(POST_WARRANTY_ADD(), formData);
      return response;
    },
    onSuccess: (response) => {
      openAlert({ model: 'message', type: 'success', message: 'เพิ่มข้อมูลสินค้าสำเร็จ' });
      reset({
        ...response,
      });
      setTimeout(() => {
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_REGISTRATION_LIST.PATH,
        });
      }, 1500);
    },
  });
  return { mutate, loading: isPending };
};
